import React from "react"
import classnames from "classnames"
import styles from "./Footer.less"
import {
  A,
  Section,
  AddressIcon,
  ButtonIcon,
  Interactive
} from 'AtomicComponents'
import componentParser from "AtomicUtils/componentParser"
import { WINDOW } from "AtomicUtils/environment"
import { dispatchEvent, createNewEvent } from 'AtomicUtils/newEvent'
import gtmHandler from "AtomicUtils/gtmHandler"
import cookieHandler from "AtomicUtils/cookieHandler"

class Footer extends React.PureComponent {
  constructor(props){
    super(props)
    this.state={
      postcode: null,
    }
  }

  componentDidMount() {
    this.setState({
      postcode: new cookieHandler().getCookie("postcode")
    })

    WINDOW.addEventListener(
      "POSTCODE_UPDATE",
      () => this._updatePostcode(),
      false
    )
  }

  _handleOpenPostcodePopup = () => {
    setTimeout(() => {
      let event = createNewEvent('POSTCODE_POPUP_OPEN')
      dispatchEvent(event)
    }, 100)
  }
      //new cookieHandler().getCookie("postcode")
  _updatePostcode = () => {

    this.setState({
      postcode: '2601'
    })
  }

  render() {
    const {
      postcode
    } = this.state
    const {
      gtm,
      copyright,
      links,
      components=[]
    } = this.props
    return (
      <div
        className={classnames({
          [styles.Footer]: true
        })}>
        <Section horizontalPadding fullWidth>
          <div
            className={classnames({
              [styles.FooterInside]: true
            })}>
            <div className={classnames({
              [styles.FooterLeft]: true
            })}>

                <div className={classnames({
                  [styles.Socials]: true
                })}>
                  {componentParser(components)}
                </div>
            </div>
            <div
            className={classnames({
              [styles.FooterRight]: true
            })}>
              {links && links.length > 0 && links.map(link =>
                <div
                  key={link.href}
                  className={classnames({
                    [styles.FooterRightLinks]: true
                  })}>
                  <A
                    href={link.href}
                    styleName='grey'
                    gtm={{
                      category: gtm && gtm.category ? gtm.category : "Footer Nav",
                      action: `Footer - Clicked "${link.label.toUpperCase()}"`
                    }}>
                    {link.label.toUpperCase()}
                  </A>
                </div>
              )}
              <div className={classnames({
                  [styles.CopyRight]: true
              })}>
                <Interactive>{copyright.toUpperCase()}</Interactive>
              </div>
            </div>
          </div>
        </Section>
      </div>
    )
  }
}


export default Footer



// WEBPACK FOOTER //
// ./src/AtomicContainers/Footer/Footer.jsx